import { get, set, del, createStore } from 'idb-keyval'

// Check if running in the browser
const isBrowser = typeof window !== 'undefined'

// Create a store only in the browser
export const customStore = isBrowser
  ? createStore('edugram-db', 'query-cache')
  : undefined

export const cacheStorage = {
  setItem: (key: string, value: any) => {
    if (!isBrowser) return Promise.resolve() // Do nothing on server
    return set(key, value, customStore)
  },
  getItem: (key: string) => {
    if (!isBrowser) return Promise.resolve(null) // Return null on server
    return get(key, customStore)
  },
  removeItem: (key: string) => {
    if (!isBrowser) return Promise.resolve() // Do nothing on server
    return del(key, customStore)
  },
}
